import React from "react";
import { useState } from "react";
import styles from "./FAQM.module.css";

export default function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "Jakie usługi są świadczone przez Państwa warsztat ?",
      answer:
        "Świadczymy usługi, które mają na celu naprawę układu napędowego, układu hamulcowego, układu kierowniczego, układu zawieszenia, układu elektrycznego i elektronicznego (wybrane moduły), ukłąd chodzenia, układ smarowania, układ wydechowy, układ paliwowy, układ klimatyzacji i wentylacji."
    },
    {
      question: "Czy można przyjechać do Państwa z własnymi częściami ?",
      answer:
        "W naszym warsztacie staramy się aby wszystko było dopracowane na 100%. Dlatego też sami dobieramy części do Państwa samochodów, mając pewność, że pasują one do danego modelu auta."
    },
    {
      question: "Jak długo trwa naprawa samochodu ?",
      answer:
        "Na czas naprawy auta ma wpływ wiele elementów: rodzaj i skomplikowanie usterki, dostępność potrzebnych części, kolejka w warsztacie oraz dodatkowe prace, które mogą pojawić się w trakcie diagnostyki. Zawsze staramy się, aby wszystko przebiegło możliwie jak najszybciej."
    },
    {
      question:
        "Jaka jest cena za poszczególne usługi ?",
      answer:
        "Ceny naszych usług ustalamy indywidulanie ponieważ każdy samochodód może wymagać innego zakresu prac, części oraz czasu."
    }
  ];

  const toggleFAQ = index => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="lightSectionContent" id="faq">
      <div className="darkSectionTitle">
        <h1>FAQ</h1>
      </div>
      <div className={styles.sectionDescription}>
        <div className={styles.faqContent}>
          {faqs.map((faq, index) =>
            <div
              key={index}
              className={`${styles.faqItem} ${activeIndex === index
                ? styles.active
                : ""}`}
            >
              <div
                className={styles.faqQuestion}
                onClick={() => toggleFAQ(index)}
              >
                {faq.question}
              </div>

              {activeIndex === index &&
                <div className={styles.faqAnswer}>
                  {faq.answer}
                </div>}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
